import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { connect } from 'react-redux';
import {
  containerQueryProps,
  getTranslation,
} from '@resy/ui-kitchen';

import BlogHero from './BlogHero';
import BlogPostGrid from './BlogPostGrid';
import HeroDetails from './HeroDetails';

import './BlogContent.scss';
import { redirectToSanitizedUrl } from '../../../../../ui-kitchen/src/utils/sanitizeTargetUrl';

const BlogContent = (props) => {
  const {
    heroIndex,
    blogPosts,
    contentTilePost,
    blogNavLinks,
    locationCode,
    locationTier,
    containerQuery,
    containerQuery: { md, lg, xl },
  } = props;

  const [internalPosts, setInternalPosts] = useState([]);

  const heroPost = blogPosts[heroIndex] || { tag: {} };
  const {
    url,
    title,
    subtitle,
    image,
    tag: { name, url: tagUrl },
  } = heroPost;

  useEffect(() => {
    const filteredPosts = blogPosts.filter((post, i) => i !== heroIndex);
    if (filteredPosts.length >= 4 && contentTilePost) {
      filteredPosts[3] = contentTilePost;
    } else if (contentTilePost) {
      filteredPosts.push(contentTilePost);
    }
    setInternalPosts(filteredPosts);
  }, [blogPosts, contentTilePost]);

  // eslint-disable-next-line no-shadow
  const onTagClick = (url) => {
    redirectToSanitizedUrl(url);
  };

  const heroDetails = (
    <HeroDetails
      blogNavLinks={blogNavLinks}
      locationCode={locationCode}
      containerQuery={containerQuery}
    />
  );

  return (
    <div
      className={cx('BlogContent', { 'BlogContent--tier2': locationTier === 2 })}
      aria-label={getTranslation({
        translationKey: 'resy_blog_content',
        fallback: 'Resy blog content',
      })}
    >
      <div className={cx('BlogContent__Hero', {
        'BlogContent__Hero--hero-only': internalPosts.length === 0 && md,
        'BlogContent__Hero--md': md,
      })}
      >
        <BlogHero
          url={url}
          tagUrl={tagUrl}
          title={title}
          subtitle={subtitle}
          image={image}
          name={name}
          onTagClick={onTagClick}
          containerQuery={containerQuery}
        />
        { (lg || xl) && heroDetails}
      </div>
      {locationTier === 1 && (
        <BlogPostGrid
          internalPosts={internalPosts}
          containerQuery={containerQuery}
          onTagClick={onTagClick}
          locationCode={locationCode}
        />

      )}
      { !(lg || xl) && <hr className="mobile-hero-details-break" />}
      { !(lg || xl) && heroDetails}
    </div>
  );
};

BlogContent.propTypes = {
  heroIndex: PropTypes.number.isRequired,
  blogPosts: PropTypes.arrayOf(PropTypes.shape({
    url: PropTypes.string,
    title: PropTypes.string,
    image: PropTypes.string,
    tag: PropTypes.shape({
      name: PropTypes.string,
      url: PropTypes.string,
    }),
  })),
  contentTilePost: PropTypes.shape({
    url: PropTypes.string,
    title: PropTypes.string,
    image: PropTypes.string,
    tag: PropTypes.shape({
      name: PropTypes.string,
      url: PropTypes.string,
    }),
  }),
  locationCode: PropTypes.string,
  locationTier: PropTypes.number,
  blogNavLinks: PropTypes.shape({
    cityName: PropTypes.string,
    willAppendCity: PropTypes.bool,
    slug: PropTypes.string,
    links: PropTypes.arrayOf(PropTypes.shape({
      url: PropTypes.string,
      title: PropTypes.string,
    })),
  }),
  containerQuery: containerQueryProps,
};

BlogContent.defaultProps = {
  blogPosts: [{ tag: {} }, { tag: {} }, { tag: {} }, { tag: {} }, { tag: {} }],
  contentTilePost: null,
  blogNavLinks: {
    cityName: null,
    willAppendCity: false,
    slug: null,
    links: null,
  },
  locationCode: 'ny',
  locationTier: 1,
  containerQuery: {},
};

const mapStateToProps = (state) => ({
  blogPosts: state.blog.blogPosts,
  blogNavLinks: state.blog.blogNavLinks,
  contentTilePost: state.naaAnnouncement?.contentTile,
});

BlogContent.displayName = 'BlogContent';
export { BlogContent as ComponentUnderTest };
export default connect(mapStateToProps)(BlogContent);
